<template>
  <v-container fluid class="container-full-bg-gray">    
  </v-container>
</template>
<script>
import { BankAccountQuery } from "@/modules/bank/application/BankAccountQuery";
import { query_dispatcher } from "@/api/client";

export default {
  name: 'BankRedirect',

  data() {
    return {   
      currentBankAccount:{}
    }
  },
  
  async mounted() {   
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('code') && urlParams.has('state')){
      try {
        await new BankAccountQuery(query_dispatcher, this).run(urlParams.get('state'));         
      } catch (error) {
          console.error('Error getting bank account', error);                
      }
      this.$router.push({name: 'bank-accounts', params: { companydb_id: this.currentBankAccount.company_id }, query: {ba_id: urlParams.get('state'), code: urlParams.get('code')}});
    } else {
      this.$router.push({name: 'bank-accounts', params: { companydb_id: this.currentBankAccount.company_id }});
    }
    
  },
}
</script> 

<style scoped>
  .container-full-bg-gray {
    height: 100%;
    background-color: var(--v-background-base);
  }
</style>